import React, { useState, useEffect } from 'react';

function withAppInstalled(WrappedComponent) {
  return function AppInstalledHOC(props) {
    const [appInstalled, setAppInstalled] = useState(false);

    useEffect(() => {
      // Check if the app is installed on the user's device
      // console.log('navigator',navigator)
      //
      // //not available in Safari
      //
      // window.location.replace(`boatlink2://`)

      // if (navigator.getInstalledRelatedApps) {
      //   navigator.getInstalledRelatedApps().then((relatedApps) => {
      //       console.log('relatedApps',relatedApps)
      //     if (relatedApps.length > 0) {
      //       setAppInstalled(true);
      //     }
      //   });
      // }
    }, []);

    return <WrappedComponent appInstalled={appInstalled} {...props} />;
  };
}

export default withAppInstalled;
